import { render, staticRenderFns } from "./ServiceRequestModal.vue?vue&type=template&id=0b65da1a&scoped=true"
import script from "./ServiceRequestModal.vue?vue&type=script&lang=ts"
export * from "./ServiceRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./ServiceRequestModal.vue?vue&type=style&index=0&id=0b65da1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65da1a",
  null
  
)

export default component.exports